var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoEntity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with imagetracer.js version 1.2.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 119.5 46 L 142.5 46 L 147 47.5 L 79.5 64 L 79.5 63 Q 95.1 50.1 119.5 46 Z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 179.5 64 Q 181.8 63.3 181 65.5 L 179.5 64 Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 77.5 65 L 76.5 67 L 77.5 65 Z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 96.5 97 L 95.5 99 L 96.5 97 Z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 86.5 103 L 85.5 105 L 86.5 103 Z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 83.5 105 L 82.5 107 L 83.5 105 Z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 80.5 107 L 79.5 109 L 80.5 107 Z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 76.5 110 L 75.5 112 L 76.5 110 Z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 222.5 110 L 221.5 112 L 222.5 110 Z "
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 206.5 113 L 205.5 115 L 206.5 113 Z "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 71.5 114 L 70.5 116 L 71.5 114 Z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 203.5 115 L 202.5 117 L 203.5 115 Z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 217.5 116 L 204.5 130 L 217.5 116 Z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 200.5 117 L 199.5 119 L 200.5 117 Z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 66.5 118 L 63.5 122 L 66.5 118 Z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 50.5 134 L 47.5 138 L 50.5 134 Z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 198.5 134 L 197.5 136 L 198.5 134 Z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 193.5 138 L 192.5 140 L 193.5 138 Z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 44.5 141 L 42.5 144 L 44.5 141 Z "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 52.5 145 L 51.5 147 L 52.5 145 Z "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 40.5 146 L 38.5 149 L 40.5 146 Z "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 36.5 151 L 35.5 153 L 36.5 151 Z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 33.5 155 L 32.5 157 L 33.5 155 Z "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 31.5 158 L 30.5 160 L 31.5 158 Z "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 24.5 168 L 23.5 170 L 24.5 168 Z "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 22.5 171 L 21.5 173 L 22.5 171 Z "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 185.5 191 L 183.5 194 L 185.5 191 Z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 180.5 195 L 179.5 197 L 180.5 195 Z "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(130,109,112)",
    stroke: "rgb(130,109,112)",
    strokeWidth: 1,
    opacity: 0.9764705882352941,
    d: "M 122.5 211 L 125 211.5 L 122.5 212 L 122.5 211 Z "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(57,57,65)",
    stroke: "rgb(57,57,65)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 147.5 47 L 150.5 49 L 152.5 49 Q 172.7 53.3 185 65.5 L 181 64.5 Q 181.8 61.9 178.5 63 L 178.5 65 L 175.5 64 L 175.5 66 L 172.5 65 L 172.5 67 L 169 66 L 168.5 68 L 165.5 67 L 165.5 69 L 162.5 68 L 162.5 70 L 159.5 69 L 159.5 71 L 156.5 70 L 156.5 72 L 153.5 71 L 153.5 73 L 150.5 72 L 150.5 74 L 147.5 73 L 147.5 74 L 149 74.5 L 147.5 75 L 144.5 74 L 55 96 L 53.5 100 L 53 98.5 Q 60.9 79.4 75.5 67 L 78 65.5 Q 77.2 62.9 80.5 64 L 84.5 62 L 88.5 62 L 147.5 47 Z "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(57,57,65)",
    stroke: "rgb(57,57,65)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 180.5 66 L 179.5 68 L 180.5 66 Z "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(57,57,65)",
    stroke: "rgb(57,57,65)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 187.5 67 L 192.5 73 L 187.5 67 Z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(57,57,65)",
    stroke: "rgb(57,57,65)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 197.5 78 L 198.5 80 L 197.5 78 Z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(57,57,65)",
    stroke: "rgb(57,57,65)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 211.5 109 L 210.5 111 L 211.5 109 Z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(57,57,65)",
    stroke: "rgb(57,57,65)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 73.5 112 L 72.5 114 L 73.5 112 Z "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(57,57,65)",
    stroke: "rgb(57,57,65)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 68.5 116 L 67.5 118 L 68.5 116 Z "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(57,57,65)",
    stroke: "rgb(57,57,65)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 61.5 122 L 51.5 133 L 61.5 122 Z "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(57,57,65)",
    stroke: "rgb(57,57,65)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 46.5 138 L 44.5 141 L 46.5 138 Z "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(57,57,65)",
    stroke: "rgb(57,57,65)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 41.5 144 L 40.5 146 L 41.5 144 Z "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 0 0 L 256 0 L 256 256 L 0 256 L 0 0 Z M 120 45 Q 91 50 75 66 L 59 85 Q 51 97 48 115 L 28 145 Q 15 168 5 196 Q 4 199 7 198 L 19 178 L 42 155 L 50 149 L 54 164 L 67 184 Q 85 205 118 212 L 145 212 L 154 210 Q 172 204 186 193 Q 207 176 214 145 Q 213 137 216 138 L 228 119 L 241 93 L 250 69 L 252 67 Q 253 64 251 65 L 241 82 L 214 108 Q 208 89 197 76 Q 184 58 162 50 L 143 45 L 120 45 Z "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 178.5 65 Q 180.8 64.3 180 66.5 L 178 67.5 L 178.5 65 Z "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 174.5 75 L 174 76.5 L 172.5 79 L 173 77.5 L 174.5 75 Z "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 236.5 89 L 235.5 91 L 236.5 89 Z "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 164.5 94 L 163.5 96 L 164.5 94 Z "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 97.5 97 L 96.5 99 L 97.5 97 Z "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 90.5 101 L 89.5 103 L 90.5 101 Z "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 220.5 101 L 222 101.5 L 219.5 103 L 220.5 101 Z "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 87.5 103 L 86.5 105 L 87.5 103 Z "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 226.5 104 L 225.5 106 L 226.5 104 Z "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 84.5 105 L 83.5 107 L 84.5 105 Z "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 81.5 107 L 80.5 109 L 81.5 107 Z "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 213.5 108 L 210.5 112 L 213.5 108 Z "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 223.5 108 L 222.5 110 L 223.5 108 Z "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 78.5 109 L 76.5 112 L 78.5 109 Z "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 121.5 111 Q 124.8 109.9 124 112.5 L 122.5 112 L 121.5 111 Z "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 74.5 112 L 72.5 115 L 74.5 112 Z "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 208.5 112 L 207.5 114 L 208.5 112 Z "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 220.5 112 L 218.5 115 L 220.5 112 Z "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 69.5 116 L 66.5 120 L 69.5 116 Z "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 201.5 117 L 200.5 119 L 201.5 117 Z "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 194.5 121 L 193.5 123 L 194.5 121 Z "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 62.5 122 L 51.5 134 L 62.5 122 Z "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 148.5 125 L 148 126.5 L 146.5 129 L 147 127.5 L 148.5 125 Z "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 202.5 130 L 199.5 134 L 202.5 130 Z "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 195.5 136 L 194.5 138 L 195.5 136 Z "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 48.5 137 L 45.5 141 L 48.5 137 Z "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 190.5 140 L 189.5 142 L 190.5 140 Z "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 57.5 141 L 56.5 143 L 57.5 141 Z "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 213.5 142 L 214 144.5 L 213 144.5 L 213.5 142 Z "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 43.5 143 L 41.5 146 L 43.5 143 Z "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 186.5 143 L 185.5 145 L 186.5 143 Z "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 183.5 145 L 182.5 147 L 183.5 145 Z "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 50.5 146 L 50 147.5 L 49.5 149 L 49 147.5 L 50.5 146 Z "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 39.5 148 L 37.5 151 L 39.5 148 Z "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 177.5 149 L 176.5 151 L 177.5 149 Z "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 36.5 152 L 34.5 155 L 36.5 152 Z "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 44.5 152 L 43.5 154 L 41.5 155 L 42.5 153 L 44.5 152 Z "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 33.5 156 L 32.5 158 L 33.5 156 Z "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 30.5 160 L 29.5 162 L 30.5 160 Z "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 28.5 163 L 27.5 165 L 28.5 163 Z "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 206.5 164 L 207 165.5 L 204.5 169 L 205 167.5 L 206.5 164 Z "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 26.5 166 L 25.5 168 L 26.5 166 Z "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 24.5 169 L 25.5 171 L 23 170.5 L 24.5 169 Z "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 202.5 172 L 201.5 174 L 202.5 172 Z "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 198.5 178 L 195.5 182 L 198.5 178 Z "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 194.5 183 L 188.5 190 L 194.5 183 Z "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 186.5 191 L 185.5 193 L 186.5 191 Z "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 178.5 197 L 177.5 199 L 178.5 197 Z "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 173.5 200 L 172.5 202 L 173.5 200 Z "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 147.5 210 L 150 210.5 L 147.5 211 L 147.5 210 Z "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,231,231)",
    stroke: "rgb(239,231,231)",
    strokeWidth: 1,
    opacity: 0.9176470588235294,
    d: "M 141.5 211 L 144 211.5 L 141.5 212 L 141.5 211 Z "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(5,5,19)",
    stroke: "rgb(5,5,19)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 178.5 63 L 181 63.5 L 172.5 66 L 172.5 65 L 178.5 63 Z "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(5,5,19)",
    stroke: "rgb(5,5,19)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 182.5 64 L 197 77.5 Q 207.6 89.9 212 108.5 Q 182 131.8 141 143 L 168 88.5 L 182.5 64 Z "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(5,5,19)",
    stroke: "rgb(5,5,19)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 165.5 67 L 168 67.5 Q 130.8 78.3 99.5 95 Q 71.8 110.3 51 132.5 Q 25.8 161.3 6.5 196 L 7 194.5 Q 22.4 149.4 49 115.5 L 51 105.5 L 55 96 L 143.5 75 L 165.5 67 Z "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(63,63,65)",
    stroke: "rgb(63,63,65)",
    strokeWidth: 1,
    opacity: 0.3333333333333333,
    d: "M 119.5 45 L 142.5 45 L 161.5 50 Q 183.5 58.5 197 75.5 L 210 97.5 L 213 108.5 L 212 108.5 Q 205.5 82 187.5 67 Q 174.5 55 155.5 49 L 142.5 46 L 119.5 46 Q 84 52.5 66 76.5 L 53 98.5 L 48 116.5 L 29 144.5 L 6.5 194 L 6 192.5 L 28 144.5 L 48 114.5 Q 50.8 96.8 59 84.5 L 74.5 66 Q 91.3 49.8 119.5 45 Z "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(63,63,65)",
    stroke: "rgb(63,63,65)",
    strokeWidth: 1,
    opacity: 0.3333333333333333,
    d: "M 24.5 171 L 19 177.5 L 6.5 198 Q 3.9 198.8 5 195.5 L 8 194.5 L 18 177.5 L 24.5 171 Z "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(151,0,0)",
    stroke: "rgb(151,0,0)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 250.5 66 L 251 67.5 L 228 117.5 L 213 140.5 L 211 152.5 L 203 170.5 L 192.5 184 L 194 181.5 L 196 177 L 189.5 174 L 168.5 159 L 165.5 159 L 160.5 162 L 161.5 160 Q 195 142.5 219 115.5 L 233 96.5 L 250.5 66 Z "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(151,0,0)",
    stroke: "rgb(151,0,0)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 121.5 112 L 123 112.5 L 115.5 126 L 111.5 121 L 105.5 119 L 100.5 121 L 100.5 120 L 121.5 112 Z "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(187,36,36)",
    stroke: "rgb(187,36,36)",
    strokeWidth: 1,
    opacity: 0.3176470588235294,
    d: "M 250.5 65 Q 252.8 64.3 252 66.5 L 249 66.5 L 250.5 65 Z "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(187,36,36)",
    stroke: "rgb(187,36,36)",
    strokeWidth: 1,
    opacity: 0.3176470588235294,
    d: "M 246.5 72 L 245.5 74 L 246.5 72 Z "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(187,36,36)",
    stroke: "rgb(187,36,36)",
    strokeWidth: 1,
    opacity: 0.3176470588235294,
    d: "M 242.5 79 L 241.5 81 L 242.5 79 Z "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(187,36,36)",
    stroke: "rgb(187,36,36)",
    strokeWidth: 1,
    opacity: 0.3176470588235294,
    d: "M 227.5 118 L 226.5 120 L 227.5 118 Z "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(187,36,36)",
    stroke: "rgb(187,36,36)",
    strokeWidth: 1,
    opacity: 0.3176470588235294,
    d: "M 224.5 123 L 223.5 125 L 224.5 123 Z "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(187,36,36)",
    stroke: "rgb(187,36,36)",
    strokeWidth: 1,
    opacity: 0.3176470588235294,
    d: "M 222.5 126 L 221.5 128 L 222.5 126 Z "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(187,36,36)",
    stroke: "rgb(187,36,36)",
    strokeWidth: 1,
    opacity: 0.3176470588235294,
    d: "M 219.5 131 L 218.5 133 L 219.5 131 Z "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(187,36,36)",
    stroke: "rgb(187,36,36)",
    strokeWidth: 1,
    opacity: 0.3176470588235294,
    d: "M 217.5 134 L 216.5 136 L 217.5 134 Z "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(187,36,36)",
    stroke: "rgb(187,36,36)",
    strokeWidth: 1,
    opacity: 0.3176470588235294,
    d: "M 50.5 150 L 51 152.5 L 50 152.5 L 50.5 150 Z "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(187,36,36)",
    stroke: "rgb(187,36,36)",
    strokeWidth: 1,
    opacity: 0.3176470588235294,
    d: "M 52.5 157 L 54 160.5 L 53 160.5 L 52.5 157 Z "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(187,36,36)",
    stroke: "rgb(187,36,36)",
    strokeWidth: 1,
    opacity: 0.3176470588235294,
    d: "M 54.5 162 L 58 168.5 L 56 167.5 L 54.5 162 Z "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(187,36,36)",
    stroke: "rgb(187,36,36)",
    strokeWidth: 1,
    opacity: 0.3176470588235294,
    d: "M 59.5 172 L 60.5 174 L 59.5 172 Z "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(187,36,36)",
    stroke: "rgb(187,36,36)",
    strokeWidth: 1,
    opacity: 0.3176470588235294,
    d: "M 61.5 175 L 62.5 177 L 61.5 175 Z "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(187,36,36)",
    stroke: "rgb(187,36,36)",
    strokeWidth: 1,
    opacity: 0.3176470588235294,
    d: "M 63.5 178 L 66.5 182 L 63.5 178 Z "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(187,36,36)",
    stroke: "rgb(187,36,36)",
    strokeWidth: 1,
    opacity: 0.3176470588235294,
    d: "M 67.5 183 L 76.5 193 L 67.5 183 Z "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(187,36,36)",
    stroke: "rgb(187,36,36)",
    strokeWidth: 1,
    opacity: 0.3176470588235294,
    d: "M 78.5 193 L 80.5 196 L 78.5 193 Z "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(187,36,36)",
    stroke: "rgb(187,36,36)",
    strokeWidth: 1,
    opacity: 0.3176470588235294,
    d: "M 82.5 196 L 83.5 198 L 82.5 196 Z "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(187,36,36)",
    stroke: "rgb(187,36,36)",
    strokeWidth: 1,
    opacity: 0.3176470588235294,
    d: "M 85.5 198 L 86.5 200 L 85.5 198 Z "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(187,36,36)",
    stroke: "rgb(187,36,36)",
    strokeWidth: 1,
    opacity: 0.3176470588235294,
    d: "M 88.5 200 L 99 205.5 L 97.5 206 L 89.5 202 L 88.5 200 Z "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(187,36,36)",
    stroke: "rgb(187,36,36)",
    strokeWidth: 1,
    opacity: 0.3176470588235294,
    d: "M 100.5 206 L 104 207.5 L 102.5 208 L 100.5 206 Z "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(187,36,36)",
    stroke: "rgb(187,36,36)",
    strokeWidth: 1,
    opacity: 0.3176470588235294,
    d: "M 108.5 209 L 111 209.5 L 108.5 210 L 108.5 209 Z "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(187,36,36)",
    stroke: "rgb(187,36,36)",
    strokeWidth: 1,
    opacity: 0.3176470588235294,
    d: "M 112.5 210 L 116 210.5 L 112.5 211 L 112.5 210 Z "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(187,36,36)",
    stroke: "rgb(187,36,36)",
    strokeWidth: 1,
    opacity: 0.3176470588235294,
    d: "M 117.5 211 L 120 211.5 L 117.5 212 L 117.5 211 Z "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 177.5 66 L 179 66.5 L 139 144 L 143.5 144 L 155.5 140 L 177.5 131 L 200.5 119 L 214 108.5 L 218.5 103 L 222 101.5 L 221.5 100 L 239.5 83 L 238 85.5 Q 224.6 111.6 203.5 130 Q 179.7 151.2 149.5 166 Q 117.8 182 82 193 L 124 111 Q 80.5 122.7 49 147.5 L 45.5 152 L 42 153.5 L 42.5 155 L 41 154.5 L 26.5 170 L 22.5 173 L 25 169.5 Q 41.8 141.3 65.5 120 Q 88.5 100 118.5 87 Q 146.3 74.8 177.5 66 Z "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 201.5 174 L 200.5 176 L 201.5 174 Z "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 181.5 195 L 180.5 197 L 181.5 195 Z "
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,1,1)",
    stroke: "rgb(198,1,1)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 61.5 139 L 60.5 141 L 61.5 139 Z "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,1,1)",
    stroke: "rgb(198,1,1)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 58.5 141 L 57.5 143 L 58.5 141 Z "
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,1,1)",
    stroke: "rgb(198,1,1)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 54.5 144 L 58.5 147 L 60 146.5 L 59.5 148 L 61.5 147 L 61.5 149 L 63.5 150 L 65 149.5 Q 62.8 150.8 65.5 152 L 67 151.5 L 66.5 150 L 68.5 154 L 70 153.5 L 69.5 152 L 71.5 156 L 73 155.5 L 72.5 154 L 74.5 158 L 76 157.5 L 75.5 156 L 77.5 160 L 79 159.5 L 78.5 158 L 80.5 162 L 82 161.5 L 81.5 160 L 83.5 164 L 85 163.5 L 84.5 162 L 86.5 166 L 88 165.5 L 87.5 164 L 89.5 168 L 91 167.5 L 90.5 166 L 92.5 171 L 91 170.5 L 92 172.5 L 90 173.5 L 90.5 175 L 89 175.5 L 89 177.5 L 80 193.5 L 82.5 194 L 103.5 186 L 105 186.5 Q 104.3 184.3 106.5 185 L 108.5 186 L 108.5 184 L 111.5 185 L 111.5 183 L 117.5 186 L 119 185.5 Q 116.8 186.7 119.5 188 L 121 187.5 L 120.5 186 L 122.5 190 L 124 189.5 L 123.5 188 L 125.5 192 L 127 191.5 L 126.5 190 L 128.5 194 L 130 193.5 L 129.5 192 L 131.5 196 L 133 195.5 L 132.5 194 L 134.5 198 L 136 197.5 L 135.5 196 L 136.5 199 L 138.5 198 L 139.5 201 L 141.5 200 L 143.5 204 L 145 203.5 L 144.5 202 L 146.5 206 L 148 205.5 L 147.5 204 L 149 205.5 L 148.5 209 L 150 209.5 L 148.5 210 L 144.5 209 L 144.5 211 L 125.5 212 L 124.5 211 L 116.5 211 L 107.5 209 L 87.5 200 Q 75.6 192.9 67 182.5 Q 54.3 169.2 50 147.5 L 52.5 147 L 54 146.5 Q 51.8 145.3 54.5 144 Z "
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,0,0)",
    stroke: "rgb(182,0,0)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 104.5 118 Q 111.4 119.5 115 124.5 L 116 126.5 L 114 127.5 L 114.5 129 L 113 129.5 L 113.5 131 L 112 131.5 L 112 133.5 L 91.5 172 L 91 170.5 Q 93.3 169.3 90.5 168 L 55.5 145 L 51.5 148 L 52.5 146 Q 72.1 130.6 97.5 121 L 99 121.5 L 99.5 120 L 101.5 121 L 101.5 119 L 104.5 120 L 104.5 118 Z "
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,0,0)",
    stroke: "rgb(182,0,0)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 164.5 158 L 168.5 159 L 189.5 174 L 196 177 L 197 179.5 L 194 180.5 L 192 183.5 L 193 184.5 L 187.5 190 Q 171.6 205.6 144.5 210 L 144.5 209 Q 148.3 209.8 149 207.5 L 116.5 185 L 112.5 184 L 107.5 186 L 107.5 185 Q 134.7 175.7 157.5 162 L 159 162.5 L 160.5 160 L 162.5 161 L 162.5 159 L 164.5 160 L 164.5 158 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEntity);
export default __webpack_public_path__ + "static/media/logoEntity.ac803ffbd68b913123202cccbaea4364.svg";
export { ForwardRef as ReactComponent };